import { Box, styled } from "@mui/material";
import { mentorshipSupport } from "./BizdevInternshipData";
import { hintCheck } from "../../UserHome/Base/SVG";

const InternshipMentorship = () => {
  return (
    <Root>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <Header>Mentorship & Support</Header>
        <SubHeader>You won't do this alone.</SubHeader>{" "}
      </Box>
      <Content>
        {mentorshipSupport.map((i, _) => (
          <MentorshipBox key={i.header}>
            <div>
              {hintCheck} <h4>{i.header}</h4>
            </div>
            <p>{i.body}</p>
          </MentorshipBox>
        ))}
      </Content>
    </Root>
  );
};

export default InternshipMentorship;

const Root = styled("h2")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "80px",
  [theme.breakpoints.down(500)]: {
    gap: "31px",
  },
}));

const Header = styled("h2")(({ theme }) => ({
  textAlign: "center",
  width: "831px",
  margin: "auto",
  fontSize: "48px",
  lineHeight: 1.33,
  fontWeight: 700,
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
    fontSize: "35px",
    lineHeight: 1.3,
  },
  [theme.breakpoints.down(500)]: {
    fontSize: "24px",
    lineHeight: "35px",
  },
}));

const SubHeader = styled("h4")(({ theme }) => ({
  textAlign: "center",
  margin: "auto",
  fontSize: "20px",
  lineHeight: "22px",
  fontWeight: 400,
}));

const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  gap: "80px",
  [theme.breakpoints.down(900)]: {
    flexDirection: "column",
    gap: "21px",
  },
}));

const MentorshipBox = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  "&>div": {
    display: "flex",
    gap: 20,
    alignItems: "center",
    "&>h4": {
      fontSize: "18px",
      lineHeight: "30px",
      fontWeight: 700,
    },
  },
  "&>p": {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#B7B7B7",
  },
}));
